var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPeople = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35762 7.49999C5.88747 7.49999 6.40543 7.34287 6.84599 7.04848C7.28654 6.7541 7.6299 6.33569 7.83265 5.84615C8.03539 5.35662 8.08842 4.81796 7.98501 4.29829C7.88161 3.77862 7.62642 3.30128 7.25172 2.92665C6.87703 2.55202 6.39965 2.29691 5.87996 2.1936C5.36027 2.09029 4.82162 2.1434 4.33212 2.34624C3.84262 2.54907 3.42427 2.8925 3.12996 3.33311C2.83565 3.77371 2.67862 4.2917 2.67871 4.82156C2.67946 5.53178 2.96195 6.21269 3.4642 6.71484C3.96644 7.217 4.6474 7.49937 5.35762 7.49999Z",
    fill: "#090E2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86172 9.71297C8.18289 9.01668 7.3119 8.53855 6.36002 8.33966C5.40814 8.14077 4.41858 8.23014 3.51774 8.59637C2.6169 8.96259 1.84568 9.58903 1.30259 10.3957C0.759497 11.2023 0.469189 12.1526 0.46875 13.125C0.46875 13.2493 0.518136 13.3685 0.606044 13.4565C0.693951 13.5444 0.81318 13.5937 0.9375 13.5937H9.77813C9.90245 13.5937 10.0217 13.5444 10.1096 13.4565C10.1975 13.3685 10.2469 13.2493 10.2469 13.125C10.2487 12.6279 10.172 12.1337 10.0195 11.6606C9.79257 10.9292 9.39583 10.2618 8.86172 9.71297Z",
    fill: "#090E2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0156 7.73438C12.1159 7.73438 13.0078 6.84244 13.0078 5.74219C13.0078 4.64193 12.1159 3.75 11.0156 3.75C9.91537 3.75 9.02344 4.64193 9.02344 5.74219C9.02344 6.84244 9.91537 7.73438 11.0156 7.73438Z",
    fill: "#090E2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0155 8.28281C10.3872 8.28517 9.77101 8.45629 9.23145 8.77827C9.33316 8.86921 9.43582 8.95874 9.53191 9.05718C10.1702 9.71322 10.6443 10.5108 10.9157 11.385C11.0086 11.6728 11.0771 11.9679 11.1205 12.2672H14.0624C14.1867 12.2672 14.3059 12.2178 14.3938 12.1299C14.4817 12.042 14.5311 11.9228 14.5311 11.7984C14.5301 10.8663 14.1594 9.9727 13.5003 9.31361C12.8412 8.65451 11.9476 8.2838 11.0155 8.28281Z",
    fill: "#090E2C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPeople);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/people.27e1efd00f794bf7afd5ad2a80de57f7.svg";